import { EcleticaCatalog } from "@/core/EcleticaCatalog";
import { UnavailableProduct } from "../expections/UnavailableProduct";
import { ProductNotFound } from "../expections/ProductNotFound";

export class CartItemBuilder {
  constructor({
    transactionId,
    cartItems = [],
    unavailableProductSkus = [],
  }) {
    this.convertedItems = [];
    this.cartItemCount = 0;

    this.cartItems = cartItems;
    this.transactionId = transactionId;
    this.unavailableProductSkus = unavailableProductSkus;
  }

  getItems() {
    this.convertedItems = [];
    this.cartItemCount = 0;

    for (let cartIndex in this.cartItems) {
      const cartItem = this.cartItems[cartIndex];
      this.convertItem(cartItem, Number(cartIndex));
    }

    return this.convertedItems;
  }

  convertItem(item, groupId) {
    if (item.type === "step") {
      this.convertStep(item, groupId);
    }

    if (item.type === "question") {
      this.convertQuestion(item, groupId);
    }

    if (item.type === "option") {
      this.convertOption(item, groupId);
    }
  }

  convertStep(sItem, groupId) {
    const mountedStep = this.buildItem(sItem, groupId);

    this.convertedItems.push(mountedStep);

    if (sItem.items.length > 0) {
      const questions = sItem?.items || [];
      questions.forEach((item) =>
        this.convertItem(
          { ...item, quantity: item.quantity * sItem.quantity },
          groupId
        )
      );
    }
  }

  convertQuestion(qItem, groupId) {
    const options = (qItem?.items || []).filter(
      (item) => item.selected === true
    );
    options.forEach((item) =>
      this.convertItem(
        { ...item, quantity: item.quantity * qItem.quantity },
        groupId
      )
    );
  }

  convertOption(oItem, groupId) {
    const mountedOption = this.buildItem(oItem, groupId);

    this.convertedItems.push(mountedOption);

    if (oItem.items.length > 0) {
      const questions = oItem?.items || [];
      questions.forEach((item) =>
        this.convertItem(
          { ...item, quantity: item.quantity * oItem.quantity },
          groupId
        )
      );
    }
  }

  buildItem(item, groupId) {
    this.cartItemCount += 1;

    const size = (item?.sizes || []).find((size) => size.sku) || {};

    const sku = size?.sku || item.sku;
    const price = size?.price || item.price;
    const total = price * item.quantity;

    const product = EcleticaCatalog.getProductBySku(sku);
    if (!product) {
      throw new ProductNotFound({
        sku,
        name: item.name,
      });
    }

    if (sku && this.unavailableProductSkus.includes(sku)) {
      throw new UnavailableProduct({
        sku,
        name: item.name,
      });
    }

    return {
      ordem: this.cartItemCount,
      cod_item: sku,
      descr_item: item.name,
      descr_item_impresso: item.name,
      quantidade: item.quantity,
      vlr_unit: price,
      posicao: 0,
      observacao: item.observation,
      multisabor: "N",
      impressao1: product.impressao1,
      impressao2: product.impressao2,
      brinde: "N",
      cod_reg: this.transactionId + groupId,
      combo: "N",
      promocao: "N",
      status: "N",
      faltante: "N",
      valor_total: total,
    };
  }
}
